import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { About } from "./pages/About";
import { CurrentListings } from "./pages/CurrentListings";
import { DreamHome } from "./pages/DreamHome";
import { HarbourIsleProperties } from "./pages/HarbourIsleProperties";
import { Home } from "./pages/Home";
import { MlsListings } from "./pages/MlsListings";
import { OpenHouses } from "./pages/OpenHouses";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfUse } from "./pages/TermsOfUse";
export function App() {
  useEffect(() => {
    document.title = "Teri Britton Real Estate of Florida";
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="31cjou2jzrr2f">
      <Routes data-id="element-1" data-mp="2wka02pum4x1q">
        <Route path="/" element={<Home data-id="element-3" data-mp="2wj8fnurpiy7c" />} data-id="element-2" data-mp="2wjqgl4pbe0ll" />
        <Route path="/about" element={<About data-id="element-5" data-mp="28u5y0mx2p5cu" />} data-id="element-4" data-mp="2whx9joashed2" />
        <Route path="/dream-home" element={<DreamHome data-id="element-7" data-mp="28suv0pbgc1ms" />} data-id="element-6" data-mp="28tmfp53igeya" />
        <Route path="/mls-listings" element={<MlsListings data-id="element-9" data-mp="23w4fq47h1a2f" />} data-id="element-8" data-mp="28s2xh8yanttv" />
        <Route path="/harbour-isle-properties" element={<HarbourIsleProperties data-id="element-11" data-mp="3ijxokogyjwiu" />} data-id="element-10" data-mp="23ujho4ly78zt" />
        <Route path="/current-listings" element={<CurrentListings data-id="element-13" data-mp="3ihv0i9zd8dgr" />} data-id="element-12" data-mp="3iiwf2oflbi38" />
        <Route path="/open-houses" element={<OpenHouses data-id="element-15" data-mp="3mk868ye44bdj" />} data-id="element-14" data-mp="3mlaxj7fckftz" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-17" data-mp="3rcj2nr9n9f1c" />} data-id="element-16" data-mp="3mjg9vlcoy9m7" />
        <Route path="/terms-of-use" element={<TermsOfUse data-id="element-19" data-mp="3reccfffk0fdk" />} data-id="element-18" data-mp="3rdatypw7kqlt" />
      </Routes>
    </BrowserRouter>;
}